// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductInquireBottomSheet_item__y_3mJ"};